define(
    'modules/magnify-image-box',[
        'jquery',
        'handlebars',
        'settings',
        'utils/body-scroll',
        'utils/bind-lifo-stack'
    ],
    function ($, handlebars, settings, bodyScroll, bindStack) {

        /**
         * @class MagnifyImageBox
         * @description Lightbox for images
         */
        var MagnifyImageBox = (function () {
            var templatePath = settings.templates.magnifyImageBox;


            /**
             * Constructor of class MagnifyImageBox
             * @param {Array} imgList           Array of images to show in the box
             * @param {Integer} currentIndex    Index of current visible image in the list
             */
            function MagnifyImageBox(imgList, currentIndex) {
                this.imgList = $.isArray(imgList) ? imgList : [imgList];    // List of images
                this.currentIndex = currentIndex ? currentIndex : 0;        // Current visible item index
                this.domImgList = false;                                    // Cached list of images in DOM
                this.currentDomImg = false;                                 // Cached current image in DOM
                this.destroyList = $.Deferred();                            // List of callbacks to be fired after the box is closed
                this.container = false;                                     // Cached magnify-image-box jquery object
                this.domImgWrapper = false;                                 // Cached wrapper block of images
                this.domImgWrapperWidth = 0;                                // Cached width of wrapper block of images
                this.domImgWrapperHeight = 0;                               // Cached height of wrapper block of images


                this.loadTemplate();
                
                var _this = this;
                this.templateLoaded.done(function () {
                    // Bindings
                    _this.bindClose();
                    _this.bindEscape();
                    _this.bindMouse();
                    _this.bindNavigation();
                });
            }

            MagnifyImageBox.prototype.show = function () {
                var _this = this;
                this.templateLoaded.done(function() {
                    _this.container = $(_this.template({
                        imgList: _this.imgList,
                        isNavigationEnabled: _this.imgList.length > 1
                    }));
                    _this.container.appendTo('body').fadeTo(0, 1);
                    _this.domImgList = _this.container.find('img, .magnify-image-box__video');
                    _this.domImgWrapper = _this.container.find('.magnify-image-box__image-list-wrapper');
                    _this.domImgWrapperWidth = _this.domImgWrapper.width();
                    _this.domImgWrapperHeight = _this.domImgWrapper.height();
                    
                    _this.initImage();

                    bodyScroll.lock();
                    _this.destroyList.done(function() {
                        _this.container.remove();
                        bodyScroll.unlock();
                    });
                });
            };

            MagnifyImageBox.prototype.loadTemplate = function (callback) {
                var _this = this;
                
                this.templateLoaded = $.get(templatePath);
                this.templateLoaded.done(function(content) {
                    _this.template = handlebars.compile(content);
                });  
            };      

            MagnifyImageBox.prototype.destroy =  function () {
                this.destroyList.resolve();
            };

            //Image
            
            MagnifyImageBox.prototype.initImage =  function () {
                this.currentDomImg = this.domImgList.eq(this.currentIndex);
                this.currentDomImg.addClass('magnify-image-box__image--active');
                this.centerImage();
                this.setupVideo();
                $(document).trigger('mousemove');
            };

            MagnifyImageBox.prototype.destroyImage =  function () {
                this.currentDomImg.removeClass('magnify-image-box__image--active');
            };

            MagnifyImageBox.prototype.centerImage =  function () {
                // The image need to be centered only on touch devices, otherwise it is implemented in CSS.
                if ( !Modernizr.touch ) {
                    return;
                }
                var imgWidth = this.currentDomImg.width(),
                    imgHeight = this.currentDomImg.height(),
                    containerWidth = this.container.width(),
                    containerHeight = this.container.height();

                if (imgWidth > containerWidth) {
                    this.domImgWrapper.scrollLeft( (imgWidth - containerWidth)/2 );
                }

                if (imgHeight > containerHeight) {
                    this.domImgWrapper.scrollTop( (imgHeight - containerHeight)/2 );
                }
            };

            MagnifyImageBox.prototype.setupVideo =  function () {
                if (this.currentDomImg.children('iframe').length) {
                    this.currentDomImg.css('width', window.innerWidth - 150 + 'px');
                    this.currentDomImg.css('height', window.innerHeight - 100 + 'px');

                    var iframe = this.currentDomImg.children('iframe').first();
                    if (iframe.attr('src') === '') {
                        iframe.attr('src', iframe.attr('playsrc'));
                    }
                }
            };

            // Navigation

            MagnifyImageBox.prototype.changeImage =  function (newIndex) {
                this.destroyImage();
                this.currentIndex = newIndex;
                this.initImage();
            };

            MagnifyImageBox.prototype.next =  function () {
                var newIndex = (this.currentIndex + 1) % this.domImgList.length;
                this.changeImage(newIndex);
            };

            MagnifyImageBox.prototype.prev =  function () {
                var newIndex = (this.currentIndex - 1 + this.domImgList.length) % this.domImgList.length;
                this.changeImage(newIndex);
            };  


            // Binding events
            
            MagnifyImageBox.prototype.bindMouse = function () {

                // Prevent binding on touch devices.
                if ( Modernizr.touch ) {
                    return;
                }

                var _this = this,
                    eventCallback = function(e) {
                        var imgWidth = _this.currentDomImg.width(),
                            imgHeight = _this.currentDomImg.height(),
                            containerWidth = _this.container.width(),
                            containerHeight = _this.container.height(),
                            imgWrapperMarginLeft = -1 * _this.domImgWrapperWidth/2 ,
                            imgWrapperMarginTop = -1 * _this.domImgWrapperHeight/2 ;

                        if (imgWidth > containerWidth) {
                            imgWrapperMarginLeft += (imgWidth - containerWidth) * (1 - 2 * e.clientX/containerWidth) / 2;
                        }

                        if (imgHeight > containerHeight) {
                            imgWrapperMarginTop += (imgHeight - containerHeight) * (1 - 2 * e.clientY/containerHeight) / 2;
                        }

                        _this.domImgWrapper.css({
                            'margin-left': imgWrapperMarginLeft + 'px',
                            'margin-top': imgWrapperMarginTop + 'px'
                        });
                    };

                $(document).on('mousemove', eventCallback);
                        
                this.destroyList.done(function() {
                    $(document).off('mousemove', eventCallback);
                });
            };

            MagnifyImageBox.prototype.bindEscape = function () {
                var _this = this;

                bindStack.pushEscapeCallback(function (e) {
                    _this.destroy();
                });

                this.destroyList.done(function() {
                    bindStack.popEscapeCallback();
                });
            };

            MagnifyImageBox.prototype.bindNavigation = function() {
                var _this = this,

                    eventCallbackLeft = function (e) {
                        e.preventDefault();
                        _this.prev();
                    },
                    eventCallbackRight = function (e) {
                        e.preventDefault();
                        _this.next();
                    },
                    eventCallbackKeydown = function (e) {
                        switch(e.which) {
                            case 37: // left
                                eventCallbackLeft(e);
                                break;
                            case 39: // right
                                eventCallbackRight(e);
                        }
                    };

                $(document)
                    .on('click', '.magnify-image-box__left', eventCallbackLeft)
                    .on('click', '.magnify-image-box__right', eventCallbackRight)
                    .on('keydown', eventCallbackKeydown);

                

                this.destroyList.done(function() {
                    $(document)
                        .off('click', '.magnify-image-box__left', eventCallbackLeft)
                        .off('click', '.magnify-image-box__right', eventCallbackRight)
                        .off('keydown', eventCallbackKeydown);
                });

                this.bindNavigateBack();
            };

            MagnifyImageBox.prototype.bindNavigateBack = function() {
                if ( !Modernizr.history ) {
                    return;
                }

                var _this = this,
                    eventNavigateBack = function(e) {
                        _this.isNavigationUsed = true;    
                        _this.destroy();
                    };

                history.pushState({}, document.title, this.href);
                $(window).on("popstate", eventNavigateBack);

                this.destroyList.done(function() {
                    $(window).off("popstate", eventNavigateBack);

                    if ( !_this.isNavigationUsed ) {
                        history.back();
                    }
                });
            };

            MagnifyImageBox.prototype.bindClose = function() {
                var _this = this,

                    eventCallback = function (e) {
                        e.preventDefault();
                        _this.destroy();
                    };

                $(document).on('click touchend', '.magnify-image-box__close', eventCallback);

                this.destroyList.done(function() {
                    $(document).off('click touchend', '.magnify-image-box__close', eventCallback);
                });
            };

            return MagnifyImageBox;
        })();

        return MagnifyImageBox;
    }
);

